<!-- Sem Lançamento -->
<sgt-cliente-analise-mercado-status-projetado-badge-nao-projetado
    *ngIf="isNaoProjetado()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-nao-projetado>
<!-- Projetado -->
<sgt-cliente-analise-mercado-status-projetado-badge-projetado
    *ngIf="isProjetado()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-projetado>
<!-- Em Negociação -->
<sgt-cliente-analise-mercado-status-projetado-badge-em-negociacao
    *ngIf="isEmNegociacao()"
    [idEtapaNegociacaoProjecao]="idEtapaNegociacaoProjecao"
    [nomeEtapaNegociacaoProjecao]="nomeEtapaNegociacaoProjecao"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-em-negociacao>
<!-- Ganho -->
<sgt-cliente-analise-mercado-status-projetado-badge-ganho
    *ngIf="isGanho()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-ganho>
<!-- Perdido -->
<sgt-cliente-analise-mercado-status-projetado-badge-perdido
    *ngIf="isPerdido()"
    [title]="title">
</sgt-cliente-analise-mercado-status-projetado-badge-perdido>